import React from 'react';
import { useTranslation } from 'react-i18next';

import { ISuppliers } from '@/modules/workforce/Crew/types';
import { Typography } from '@/shared/components/atoms';

interface IProps {
  contactInfo?: ISuppliers.IContactInfo;
  internalInfo?: ISuppliers.IInternalInfo;
}
export function ContactInfo({ contactInfo, internalInfo }: IProps) {
  const { t } = useTranslation('common');
  /************************************* api ************************************ */

  return (
    <div className='flex gap-16'>
      <CardInfo
        title={t('contact-info')}
        label={t('phone-number')}
        value={contactInfo?.phoneNumber}
      />
      <CardInfo
        title={t('internal-info')}
        label={t('company-code')}
        value={internalInfo?.customId}
      />
    </div>
  );
}

const CardInfo = ({
  title,
  label,
  value,
}: {
  title: string;
  label: string;
  value?: string | number | null;
}) => {
  return (
    <div className='w-full rounded-xl bg-white p-16'>
      <Typography weight='bold' variant='subtitle' className='mb-16 capitalize'>
        {title}
      </Typography>
      <Typography variant='body2' className='mb-8 capitalize text-text-600'>
        {label}
      </Typography>
      <Typography variant='body1' weight='medium'>
        {value || '-'}
      </Typography>
    </div>
  );
};
